import { resources, type Locale } from "@sms/i18n";

type Bundle = (typeof resources)["en"]["common"];

function lookup(bundle: Bundle, path: string): string | undefined {
  const parts = path.split(".");
  let cur: unknown = bundle;
  for (const part of parts) {
    if (typeof cur !== "object" || cur === null) return undefined;
    cur = (cur as Record<string, unknown>)[part];
  }
  return typeof cur === "string" ? cur : undefined;
}

function interpolate(template: string, vars: Record<string, string>): string {
  return template.replace(/\{\{(\w+)\}\}/g, (_, name) => vars[name] ?? `{{${name}}}`);
}

export function makeT(locale: Locale): (key: string, vars?: Record<string, string>) => string {
  const bundle = resources[locale].common;
  return (key, vars) => {
    const raw = lookup(bundle, key);
    if (raw === undefined) return key;
    return vars ? interpolate(raw, vars) : raw;
  };
}
